export type {SpectrumBarSliderBase} from '../../../src/slider/SliderBase';
